export enum FilterFormFields {
    'RECEIVED_READ' = 'receivedRead',
    'RECEIVED_UNREAD' = 'receivedUnread',
    'SENT_READ' = 'sentRead',
    'SENT_UNREAD' = 'sentUnread',
}
